import React from 'react';
import {Task} from 'api';
import styled from 'styled-components';
import {Row} from 'react-table';

interface Props {
  row: Row<Task>;
}

const Cell = ({row}: Props) => {
  const task = row.original;
  const {user} = task;

  return (
    <Container>
      <div>
        {user?.lastName} {user?.firstName}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default Cell;
